export const FooterData = [
  {
    titleHeader: "Company",
    title: [
      {
        Name: "About Us",
        href: "about-us",
      },
      {
        Name: "Contact Us",
        href: "contact-us",
      },
      {
        Name: "FAQ",
        href: "FAQ",
      },
    ],
  }
];
